import { Typography, styled } from '@mui/material';

export const TypographyDownloadLinkStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
}));
